import styles from './Outlet.module.css';
import {
  Card,
  Box,
  Modal,
  Fade,
  Backdrop,
  TextField,
  Select,
  MenuItem,
  CircularProgress,
} from '@mui/material';
import LiveLocation from 'src/pages/LiveLocation';
import { useRef, useEffect } from 'react';
import { useState } from 'react';

export default function ChainStorePage() {
  const PRIMARY = '#AF3585';
  const [activeTab, setActiveTab] = useState('all');
  const [open, setOpen] = useState(false);
  const [isPending, setIsPending] = useState(false);
  const [form, setForm] = useState({
    store_name: '',
    store_manager: '',
    store_email: '',
    store_phone_number: '',
    store_address: '',
    country: '',
    state: '',
    store_category: 'Kiosk',
    onboarded_by: 'Myself',
    logo: null,
  });

  const [stores, setStores] = useState([
    {
      store_name: 'Store 1',
      shopID: 'RX123456',
      store_manager: 'Irina Shark',
      store_email: 'shoprite@gmail.com',
      store_phone_number: '+2348400000000',
      store_address: '76, Sukami Adeklule street, Yaba, Lagos, Nigeria',
    },
    {
      store_name: 'Shoprite',
      shopID: 'RX123456',
      store_manager: 'Clint Johnson',
      store_email: 'shoprite@gmail.com',
      store_phone_number: '+2348400000000',
      store_address: '76, Sukami Adeklule street, Yaba, Lagos Nigeria',
    },
    {
      store_name: 'Prime Mart',
      shopID: 'RX123456',
      store_manager: 'Alexandra Jameson',
      store_email: 'shoprite@gmail.com',
      store_phone_number: '+2348400000000',
      store_address: '76, Sukami Adeklule street, Yaba, Lagos Nigeria',
    },
    {
      store_name: 'Justrite',
      shopID: 'RX123456',
      store_manager: 'Mattew Kolarov',
      store_email: 'shoprite@gmail.com',
      store_phone_number: '+2348400000000',
      store_address: '76, Sukami Adeklule street, Yaba, Lagos, Nigeria',
    },
  ]);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleLogoChange = (e) => {
    const file = e.target.files && e.target.files[0] ? e.target.files[0] : null;
    setForm((prev) => ({ ...prev, logo: file }));
  };

  // Actions: reassign and delete
  const [selectedIndex, setSelectedIndex] = useState(null);
  const [openReassign, setOpenReassign] = useState(false);
  const [reassignForm, setReassignForm] = useState({ storeIndex: null, manager: '', email: '', password: '' });
  const [reassignPending, setReassignPending] = useState(false);
  const [openDelete, setOpenDelete] = useState(false);
  const [deleting, setDeleting] = useState(false);
  const [openAssign, setOpenAssign] = useState(false);
  const [assignPending, setAssignPending] = useState(false);
  const [assignForm, setAssignForm] = useState({ storeIndex: null, manager: '', email: '', password: '' });

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsPending(true);
    setTimeout(() => {
      setStores((prev) => [
        {
          store_name: form.store_name || 'New Store',
          shopID: 'RX' + Math.floor(100000 + Math.random() * 900000),
          store_manager: form.store_manager,
          store_email: form.store_email,
          store_phone_number: form.store_phone_number,
          store_address: `${form.store_address}${form.state ? ', ' + form.state : ''}${form.country ? ', ' + form.country : ''}`,
        },
        ...prev,
      ]);
      setForm({
        store_name: '',
        store_manager: '',
        store_email: '',
        store_phone_number: '',
        store_address: '',
        country: '',
        state: '',
      });
      setIsPending(false);
      handleClose();
    }, 500);
  };

  const handleOpenReassign = (index) => {
    setSelectedIndex(index);
    const st = stores[index];
    setReassignForm({ storeIndex: index, manager: st?.store_manager || '', email: st?.store_email || '', password: '' });
    setOpenReassign(true);
  };

  const handleCloseReassign = () => setOpenReassign(false);

  const handleReassignChange = (e) => {
    const { name, value } = e.target;
    setReassignForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmitReassign = (e) => {
    e.preventDefault();
    setReassignPending(true);
    setTimeout(() => {
      setStores((prev) =>
        prev.map((s, i) => (i === Number(reassignForm.storeIndex)
          ? { ...s, store_manager: reassignForm.manager, store_email: reassignForm.email }
          : s))
      );
      setReassignPending(false);
      setOpenReassign(false);
      setSelectedIndex(null);
    }, 300);
  };

  const handleOpenDelete = (index) => {
    setSelectedIndex(index);
    setOpenDelete(true);
  };
  const handleCloseDelete = () => setOpenDelete(false);

  const handleConfirmDelete = () => {
    setDeleting(true);
    setTimeout(() => {
      setStores((prev) => prev.filter((_, i) => i !== selectedIndex));
      setDeleting(false);
      setOpenDelete(false);
      setSelectedIndex(null);
    }, 300);
  };

  // Map View (Google Maps)
  const mapRef = useRef(null);
  const [mapInstance, setMapInstance] = useState(null);

  useEffect(() => {
    if (activeTab !== 'map') return;
    if (typeof window !== 'undefined' && window.google && mapRef.current) {
      const center = { lat: 6.508, lng: 3.371 }; // Default Lagos center
      const m = new window.google.maps.Map(mapRef.current, {
        center,
        zoom: 12,
        mapTypeControl: false,
        streetViewControl: false,
      });
      setMapInstance(m);
    }
  }, [activeTab]);

  useEffect(() => {
    if (activeTab !== 'map' || !mapInstance || !(window && window.google)) return;
    const geocoder = new window.google.maps.Geocoder();
    const bounds = new window.google.maps.LatLngBounds();
    stores.forEach((s) => {
      if (!s.store_address) return;
      geocoder.geocode({ address: s.store_address }, (results, status) => {
        if (status === 'OK' && results && results[0]) {
          const loc = results[0].geometry.location;
          bounds.extend(loc);
          new window.google.maps.Marker({
            position: loc,
            map: mapInstance,
            title: s.store_name,
            icon: { url: '/assets/icons/mapIndicator.svg', scaledSize: new window.google.maps.Size(24, 24) },
          });
          mapInstance.fitBounds(bounds);
        }
      });
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeTab, mapInstance, stores]);

  const handleOpenAssign = (index = null) => {
    setAssignForm({
      storeIndex: typeof index === 'number' ? index : 0,
      manager: '',
      email: '',
      password: '',
    });
    setOpenAssign(true);
  };

  const handleCloseAssign = () => setOpenAssign(false);

  const handleAssignChange = (e) => {
    const { name, value } = e.target;
    setAssignForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmitAssign = (e) => {
    e.preventDefault();
    if (assignForm.storeIndex === null) return;
    setAssignPending(true);
    setTimeout(() => {
      setStores((prev) =>
        prev.map((s, i) =>
          i === Number(assignForm.storeIndex)
            ? { ...s, store_manager: assignForm.manager, store_email: assignForm.email }
            : s
        )
      );
      setAssignPending(false);
      setOpenAssign(false);
    }, 300);
  };

  return (
    <div className="mt-4 px-2">
      <div className="d-flex justify-content-end mb-3">
        <button className="btn" style={{ background: '#fff', border: '1px solid #D0D5DD', color: '#111827' }}>CSV Bulk Upload</button>
      </div>

      <div className="d-flex mb-3">
        <div
          onClick={() => setActiveTab('all')}
          className="mr-3"
          style={{
            borderBottom: activeTab === 'all' ? `2px solid ${PRIMARY}` : '2px solid transparent',
            paddingBottom: 8,
            color: activeTab === 'all' ? '#111827' : '#667085',
            fontWeight: 600,
            cursor: 'pointer',
          }}
        >
          All Stores
        </div>
        <div
          onClick={() => setActiveTab('assign')}
          className="mr-3"
          style={{
            borderBottom: activeTab === 'assign' ? `2px solid ${PRIMARY}` : '2px solid transparent',
            paddingBottom: 8,
            color: activeTab === 'assign' ? '#111827' : '#667085',
            fontWeight: 600,
            cursor: 'pointer',
          }}
        >
          Assign Stores
        </div>
        <div
          onClick={() => setActiveTab('map')}
          className="mr-3"
          style={{
            borderBottom: activeTab === 'map' ? `2px solid ${PRIMARY}` : '2px solid transparent',
            paddingBottom: 8,
            color: activeTab === 'map' ? '#111827' : '#667085',
            fontWeight: 600,
            cursor: 'pointer',
          }}
        >
          Map View
        </div>
      </div>

      {activeTab === 'all' && (
      <div className={`${styles.analytics}`}>
        <div className="row">
          <div className="col-md-6 mb-2">
            <div className={`${styles.card}`}>
              <div className="card-body">
                <div className="d-flex justify-content-between"><small>No of Stores</small><small className="text-muted">This is your Data for All time</small></div>
                <div className={`${styles.numbers}`}>
                  <div>
                    <span>{stores.length}</span>
                    <small className="ml-2 text-muted">from 7</small>
                  </div>
                  <div>
                    <span style={{ background: '#D1FAE5', color: '#065F46', padding: '2px 8px', borderRadius: 20, fontSize: 12 }}>↑ 3%</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-6 mb-2">
            <div className={`${styles.card}`}>
              <div className="card-body">
                <div className="d-flex justify-content-between"><small>Location</small><small className="text-muted">&nbsp;</small></div>
                <div className={`${styles.numbers }`} >
                  <div>
                    <span style={{color: PRIMARY ,}}>{Math.max(1, Math.min(12, new Set(stores.map((s)=>s.store_address.split(',').pop()?.trim())).size))}</span>
                    <small className="ml-2 text-muted">from 0</small>
                  </div>
                  <div>
                    <span style={{  background: '#D1FAE5', color: '#065F46', padding: '2px 8px', borderRadius: 20, fontSize: 12 }}>↑ 12%</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      )}

      {activeTab !== 'map' && (
      <div className={`${styles.filters} mt-4`}>
        <div className="row">
          <div className={`${styles.hold_input} col-md-3 col-6`}>
            <img src="/assets/icons/search.svg" alt="" />
            <input
              type="text"
              placeholder="Search"
              style={{ textIndent: '25px', width: '100%' }}
              className="form-control"
              onChange={() => {}}
            />
          </div>
          <div className="col-md-9 col-6 text-right">
            <button className="btn border" style={{ backgroundColor: '#fff', border: '1px solid #D0D5DD', boxShadow: '0px 1px 2px rgba(16, 24, 40, 0.05)', borderRadius: '4px' }}>
              <img className="" style={{ display: 'inline', width: '17px' }} src="/assets/icons/filterlines.svg" alt="" />
              &nbsp;
              <small className="d-none d-md-inline-block">Filters</small>
            </button>
          </div>
        </div>
      </div>
      )}

      <Card style={{ marginTop: '50px', borderRadius: '10px' }} className="p-0">
        <div className="p-3">
          <div className="d-md-flex justify-content-between">
            <div className="pb-3 pb-md-0">
              <h5 className="table_desc_header">Stores</h5>
              <small style={{ fontWeight: 200, fontSize: 12, display: 'inline-block', marginTop: 0 }}>Detailed information of all Stores</small>
            </div>
            <div className="pt-md-2">
              {activeTab !== 'map' && (
                <div className="btn-group align-middle mr-3" role="group" aria-label="export">
                  <button className="btn" style={{ border: `1px solid ${PRIMARY}`, color: PRIMARY, background: '#fff' }}>
                    <img src="/assets/icons/downloadblue.svg" alt="" />
                  </button>
                  <button className="btn" style={{ borderTop: `1px solid ${PRIMARY}`, borderBottom: `1px solid ${PRIMARY}`, borderRight: `1px solid ${PRIMARY}`, borderLeft: 'none', color: PRIMARY, background: '#fff' }}>
                    Export
                  </button>
                  <button className="btn" style={{ borderTop: `1px solid ${PRIMARY}`, borderBottom: `1px solid ${PRIMARY}`, borderLeft: 'none', color: PRIMARY, background: '#fff' }}>
                    ▾
                  </button>
                </div>
              )}
              {activeTab === 'all' && (
                <button onClick={handleOpen} className={`btn mt-2 mt-md-0`} style={{ backgroundColor: PRIMARY, color: '#fff', borderColor: PRIMARY }}>
                  <img src="/assets/icons/plus.svg" className="pr-1" alt="" />
                  Add New Store
                </button>
              )}
              {activeTab === 'assign' && (
                <button onClick={() => handleOpenAssign()} className={`btn mt-2 mt-md-0`} style={{ backgroundColor: PRIMARY, color: '#fff', borderColor: PRIMARY }}>
                  + Assign Store
                </button>
              )}
            </div>
          </div>
        </div>

        <div className={`pt-3 pb-3 pl-0 pr-0`}>
          {activeTab === 'all' && (
            <table className={` table-hover table-striped`} style={{ minWidth: '100em' }}>
              <thead className={`${styles.thead}`}>
                <tr>
                  <th className="px-4 text-muted ">Store name</th>
                  <th className="px-4">Store Manager</th>
                  <th className="px-4">Email Address</th>
                  <th className="px-4">Phone Number</th>
                  <th className="px-4">Store Location</th>
                </tr>
              </thead>
              <tbody>
                {stores.map((el, i) => (
                  <tr key={i} className={`${styles.tr}`}>
                    <td>
                      <div>
                        <p className="mb-0" style={{ fontSize: '12px' }}><strong>{el.store_name}</strong></p>
                        <small>{el.shopID}</small>
                      </div>
                    </td>
                    <td>{el.store_manager || '---'}</td>
                    <td>{el.store_email || '---'}</td>
                    <td>{el.store_phone_number || '---'}</td>
                    <td>{el.store_address || '---'}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
          {activeTab === 'assign' && (
            <table className={` table-hover table-striped`} style={{ width: '100%' }}>
              <thead className={`${styles.thead}`}>
                <tr>
                  <th className="px-4 text-muted ">Store name</th>
                  <th className="px-4 text-muted ">Assigned Manager</th>
                  <th className="px-4 text-muted ">Store Location</th>
                  <th className="px-4 text-muted " style={{ width: '200px', textAlign: 'right' }}>Action</th>
                </tr>
              </thead>
              <tbody>
                {stores.map((el, i) => (
                  <tr key={i} className={`${styles.tr}`}>
                    <td>
                      <div>
                        <p className="mb-0" style={{ fontSize: '12px' }}><strong>{el.store_name}</strong></p>
                        <small>{el.shopID}</small>
                      </div>
                    </td>
                    <td>
                      <div style={{ fontWeight: 600, color: '#111827' }}>{el.store_manager || '---'}</div>
                      <div className="text-muted" style={{ fontSize: 12 }}>{el.store_email || '---'}</div>
                    </td>
                    <td>{el.store_address || '---'}</td>
                    <td style={{ textAlign: 'right' }}>
                      <button
                        type="button"
                        className="btn btn-sm mr-2"
                        onClick={() => handleOpenReassign(i)}
                        style={{ border: `1px solid ${PRIMARY}`, color: PRIMARY, background: '#fff' }}
                      >
                        Reassign
                      </button>
                      <button
                        type="button"
                        className="btn btn-sm p-1"
                        onClick={() => handleOpenDelete(i)}
                        style={{ background: 'transparent', border: 'none' }}
                        aria-label="Delete store"
                        title="Delete store"
                      >
                        <img src="/assets/icons/trash-2.svg" alt="delete" style={{ width: 18, height: 18, filter: 'invert(37%) sepia(94%) saturate(5036%) hue-rotate(350deg) brightness(97%) contrast(94%)' }} />
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
          {activeTab === 'map' && (
            <div className="p-3">
              <div className="row">
                <div className="col-md-12">
                  <div style={{ height: 500, borderRadius: 10, overflow: 'hidden', border: '1px solid #E5E7EB', position: 'relative' }}>
                    <div ref={mapRef} style={{ width: '100%', height: '100%' }} />
                    <div className={`${styles.mapSearchWrapper}`} style={{ position: 'absolute', top: 12, left: 12, zIndex: 2 }}>
                      <LiveLocation label="Search" rootClassName={`${styles.mapSearchInput}`} placeholder="Search Places ..." passData={(val) => {
                        if (!mapInstance || !(window && window.google)) return;
                        const position = { lat: val.lat, lng: val.lng };
                        mapInstance.setCenter(position);
                        mapInstance.setZoom(14);
                        new window.google.maps.Marker({ position, map: mapInstance });
                      }} />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </Card>
      {activeTab !== 'map' && (
        <div className="d-flex justify-content-between align-items-center px-3 pb-3 mt-3">
          <small>Page 1 of 10</small>
          <div>
            <button className="btn mr-2" style={{ border: `1px solid #D0D5DD`,  background: '#fff' }}>Previous</button>
            <button className="btn" style={{  border: `1px solid #D0D5DD`,  background: '#fff' }}>Next</button>
          </div>
        </div>
      )}

      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={open}
        onClose={handleClose}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{ timeout: 500 }}
        disableEnforceFocus
      >
        <Fade in={open}>
          <Box sx={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', width: 520, maxHeight: '90vh',  overflowY: 'auto', bgcolor: '#F5F5F5', border: '1px solid #F5F5F5', borderRadius: '5px', boxShadow: 24, p: 4 }} className={`mobile_modal_size`}>
            <div className={`${styles.modal_content}`}>
              <div className={`${styles.modal_header} mb-0`}>
                <div>
                  <h5 style={{ fontSize: '19px', fontWeight: 700 }}>Add Store</h5>
                  <p style={{ fontSize: '11px', color: '#71717A' }}>Add information about this store</p>
                </div>
                <div>
                  <span onClick={handleClose} style={{ cursor: 'pointer' }}>
                    <img src="/assets/icons/x.svg" alt="" />
                  </span>
                </div>
              </div>

              <form onSubmit={handleSubmit} className="mt-0 form_label">
                <div className="mb-3">
                  <label>Upload Business Logo*</label>
                  <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                    <div style={{ width: 64, height: 64, border: '1px solid #E5E7EB', borderRadius: 12, display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#F9FAFB' }}>
                      <img src="/assets/icons/profile.svg" alt="logo" style={{ width: 28, opacity: 0.6 }} />
                    </div>
                    <div>
                      <input id="store_logo" type="file" accept="image/*" className="d-none" onChange={handleLogoChange} />
                      <button type="button" className="btn" style={{ border: '1px solid #D0D5DD', background: '#fff' }} onClick={() => document.getElementById('store_logo').click()}>
                        Choose file
                      </button>
                      {form.logo && <small className="ml-2">{form.logo.name}</small>}
                    </div>
                  </div>
                </div>
                <div className="mb-3">
                  <label htmlFor="store_category">Store Category*</label>
                  <Select
                    id="store_category"
                    name="store_category"
                    value={form.store_category}
                    onChange={handleChange}
                    fullWidth
                    size="small"
                  >
                    <MenuItem value="Kiosk">Kiosk</MenuItem>
                    <MenuItem value="Neighborhood store">Ministore</MenuItem>
                    <MenuItem value="Supermarket">Supermarket</MenuItem>
                    <MenuItem value="E-commerce store">E-commerce store</MenuItem>
                  </Select>
                </div>
                <div className="mb-3">
                  <label htmlFor="name">Store Name*</label>
                  <TextField required type="text" value={form.store_name} name="store_name" onChange={handleChange} id="name" size="small" fullWidth />
                </div>
                <div className="mb-3">
                  <label htmlFor="onboarded_by">Onboarded by*</label>
                  <Select id="onboarded_by" name="onboarded_by" value={form.onboarded_by} onChange={handleChange} fullWidth size="small">
                    <MenuItem value="Myself">Myself</MenuItem>
                    <MenuItem value="Agent">Agent</MenuItem>
                  </Select>
                </div>
                <div className="mb-3">
                  <label htmlFor="addr">Business Address*</label>
                  <TextField required id="addr" size="small" fullWidth value={form.store_address} name="store_address" onChange={handleChange} placeholder="Line 1" />
                </div>
                <div className="row">
                  <div className="col-md-6 mb-1">
                    <label htmlFor='country'>Country*</label>
                    <Select value={form.country} onChange={(e)=>setForm((p)=>({...p, country: e.target.value}))} fullWidth size="small" displayEmpty>
                      <MenuItem value="">Select Country</MenuItem>
                      <MenuItem value="Nigeria">Nigeria</MenuItem>
                      <MenuItem value="Kenya">Kenya</MenuItem>
                      <MenuItem value="Ghana">Ghana</MenuItem>
                    </Select>
                  </div>
                  <div className="col-md-6 mb-1">
                    <label htmlFor="state">State*</label>
                    <Select value={form.state} onChange={(e)=>setForm((p)=>({...p, state: e.target.value}))} fullWidth size="small" displayEmpty disabled={!form.country}>
                      <MenuItem value="">Select State</MenuItem>
                      {form.country === 'Nigeria' && (
                        <>
                          <MenuItem value="Lagos">Lagos</MenuItem>
                          <MenuItem value="Abuja">Abuja</MenuItem>
                          <MenuItem value="Rivers">Rivers</MenuItem>
                        </>
                      )}
                    </Select>
                  </div>
                </div>
                <div className="mb-3">
                  <label htmlFor="phone">Business Phone Number*</label>
                  <TextField required type="phone" value={form.store_phone_number} name="store_phone_number" onChange={handleChange} id="phone" size="small" fullWidth />
                </div>
                <div className="mb-3">
                  <label htmlFor="email">Business Email*</label>
                  <TextField required type="email" value={form.store_email} name="store_email" onChange={handleChange} id="email" size="small" fullWidth />
                </div>
                <div className="mb-1 mt-4">
                  {!isPending && (
                    <button type="submit" className={`btn btn-block`} style={{ background: PRIMARY, color: '#fff' }}>Add Store</button>
                  )}
                  {isPending && (
                    <button disabled className={`btn btn-block`} style={{ background: PRIMARY, color: '#fff' }}>
                      Submitting &nbsp;<CircularProgress style={{ color: '#fff' }} size="1rem" />
                    </button>
                  )}
                </div>
              </form>
            </div>
          </Box>
        </Fade>
      </Modal>

      {/* Assign Store Modal */}
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={openAssign}
        onClose={handleCloseAssign}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{ timeout: 500 }}
        disableEnforceFocus
      >
        <Fade in={openAssign}>
          <Box sx={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', width: 520, maxHeight: '90vh',  overflowY: 'auto', bgcolor: '#F5F5F5', border: '1px solid #F5F5F5', borderRadius: '5px', boxShadow: 24, p: 4 }} className={`mobile_modal_size`}>
            <div className={`${styles.modal_content}`}>
              <div className={`${styles.modal_header} mb-0`}>
                <div>
                  <h5 style={{ fontSize: '19px', fontWeight: 700 }}>Assign Store</h5>
                  <p style={{ fontSize: '11px', color: '#71717A' }}>Please enter the relevant details.</p>
                </div>
                <div>
                  <span onClick={handleCloseAssign} style={{ cursor: 'pointer' }}>
                    <img src="/assets/icons/x.svg" alt="" />
                  </span>
                </div>
              </div>

              <form onSubmit={handleSubmitAssign} className="mt-0 form_label">
                <div className="mb-3">
                  <label htmlFor="astore">Select Store</label>
                  <Select id="astore" name="storeIndex" value={assignForm.storeIndex ?? ''} onChange={handleAssignChange} fullWidth size="small">
                    {stores.map((s, idx) => (
                      <MenuItem key={idx} value={idx}>{s.store_name}</MenuItem>
                    ))}
                  </Select>
                </div>
                <div className="mb-3">
                  <label htmlFor="amanager">Manager Name*</label>
                  <TextField id="amanager" name="manager" value={assignForm.manager} onChange={handleAssignChange} placeholder="Enter business name" size="small" fullWidth required />
                </div>
                <div className="mb-3">
                  <label htmlFor="aemail">Manager Email*</label>
                  <TextField id="aemail" type="email" name="email" value={assignForm.email} onChange={handleAssignChange} size="small" fullWidth required />
                </div>
                <div className="mb-3">
                  <label htmlFor="apass">Create Password</label>
                  <TextField id="apass" type="password" name="password" value={assignForm.password} onChange={handleAssignChange} size="small" fullWidth />
                </div>
                <div className="mb-1 mt-4">
                  {!assignPending && (
                    <button type="submit" className={`btn btn-block`} style={{ background: PRIMARY, color: '#fff' }}>Send Invite</button>
                  )}
                  {assignPending && (
                    <button disabled className={`btn btn-block`} style={{ background: PRIMARY, color: '#fff' }}>
                      Sending &nbsp;<CircularProgress style={{ color: '#fff' }} size="1rem" />
                    </button>
                  )}
                </div>
              </form>
            </div>
          </Box>
        </Fade>
      </Modal>

      {/* Reassign Manager Modal */}
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={openReassign}
        onClose={handleCloseReassign}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{ timeout: 500 }}
        disableEnforceFocus
      >
        <Fade in={openReassign}>
          <Box sx={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', width: 520, maxHeight: '90vh',  overflowY: 'auto', bgcolor: '#F5F5F5', border: '1px solid #F5F5F5', borderRadius: '5px', boxShadow: 24, p: 4 }} className={`mobile_modal_size`}>
            <div className={`${styles.modal_content}`}>
              <div className={`${styles.modal_header} mb-0`}>
                <div>
                  <h5 style={{ fontSize: '19px', fontWeight: 700 }}>Reassign Manager</h5>
                  <p style={{ fontSize: '11px', color: '#71717A' }}>Update the manager for this store</p>
                </div>
                <div>
                  <span onClick={handleCloseReassign} style={{ cursor: 'pointer' }}>
                    <img src="/assets/icons/x.svg" alt="" />
                  </span>
                </div>
              </div>

              <form onSubmit={handleSubmitReassign} className="mt-0 form_label">
                <div className="mb-3">
                  <label htmlFor="rstore">Select Store</label>
                  <Select id="rstore" name="storeIndex" value={reassignForm.storeIndex ?? ''} onChange={handleReassignChange} fullWidth size="small">
                    {stores.map((s, idx) => (
                      <MenuItem key={idx} value={idx}>{s.store_name}</MenuItem>
                    ))}
                  </Select>
                </div>
                <div className="mb-3">
                  <label htmlFor="rmanager">Manager Name</label>
                  <TextField required type="text" id="rmanager" size="small" fullWidth name="manager" value={reassignForm.manager} onChange={handleReassignChange} />
                </div>
                <div className="mb-3">
                  <label htmlFor="remail">Manager Email</label>
                  <TextField required type="email" id="remail" size="small" fullWidth name="email" value={reassignForm.email} onChange={handleReassignChange} />
                </div>
                <div className="mb-3">
                  <label htmlFor="rpass">Create Password</label>
                  <TextField type="password" id="rpass" size="small" fullWidth name="password" value={reassignForm.password} onChange={handleReassignChange} />
                </div>
                <div className="mb-1 mt-4">
                  {!reassignPending && (
                    <button type="submit" className={`btn btn-block`} style={{ background: PRIMARY, color: '#fff' }}>Save</button>
                  )}
                  {reassignPending && (
                    <button disabled className={`btn btn-block`} style={{ background: PRIMARY, color: '#fff' }}>
                      Saving &nbsp;<CircularProgress style={{ color: '#fff' }} size="1rem" />
                    </button>
                  )}
                </div>
              </form>
            </div>
          </Box>
        </Fade>
      </Modal>

      {/* Delete Confirmation Modal */}
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={openDelete}
        onClose={handleCloseDelete}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{ timeout: 500 }}
        disableEnforceFocus
      >
        <Fade in={openDelete}>
          <Box sx={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', width: 520, maxHeight: '90vh',  overflowY: 'auto', bgcolor: '#F5F5F5', border: '1px solid #F5F5F5', borderRadius: '5px', boxShadow: 24, p: 4 }} className={`mobile_modal_size`}>
            <div className={`${styles.modal_content}`}>
              <div className={`${styles.modal_header} mb-0`}>
                <div>
                  <h5 style={{ fontSize: '19px', fontWeight: 700 }}>Delete {selectedIndex !== null ? stores[selectedIndex]?.store_name : ''} Store</h5>
                  <p style={{ fontSize: '11px', color: '#71717A' }}>Are you sure you want to delete this store? This action cannot be undone.</p>
                </div>
                <div>
                  <span onClick={handleCloseDelete} style={{ cursor: 'pointer' }}>
                    <img src="/assets/icons/x.svg" alt="" />
                  </span>
                </div>
              </div>
              <div className="d-flex justify-content-end">
                <button className={`btn mr-2 ${styles.cancel_delete}`} onClick={handleCloseDelete}>Cancel</button>
                {!deleting && (
                  <button className={`btn ${styles.delete_product}`} onClick={handleConfirmDelete}>Delete</button>
                )}
                {deleting && (
                  <button disabled className={`btn ${styles.delete_product}`}>
                    <CircularProgress style={{ color: 'white' }} size="1rem" />
                  </button>
                )}
              </div>
            </div>
          </Box>
        </Fade>
      </Modal>
    </div>
  );
}


